// Payments voided/returned in Usio are marked status = true by the void-return cron,
// with status_payment holding the Usio status (e.g. 'Payment Voided', 'R01').
export const paymentVoidReturnLabel = (payment) => {
  if (payment?.status !== true) return null;
  return /void/i.test(payment?.status_payment || '') ? 'VOID' : 'RETURN';
};

export const VOID_RETURN_BG = '#ffcccc';
export const VOID_RETURN_COLOR = '#c62828';
